/* eslint-disable global-require */
module.exports = ['layouts.header.m46', 'marketplace.sellermenu.m13'];
